import React from 'react';
import './IndexPage.css';

const Card = ({ title, description, link }) => (
  <div className="card">
    <h2>{title}</h2>
    <p>{description}</p>
    <a href={link} target="_blank" rel="noopener noreferrer" className="card-link">
      Visit Profile
    </a>
  </div>
);

const IndexPage = () => {
  const cards = [
    {
      title: 'LinkedIn',
      description: 'Explore professional interests, connections, and ongoing projects.',
      link: 'https://www.linkedin.com/in/joe-bodden/',
    },
    {
      title: 'GitHub',
      description: 'Dive into the source code behind this modular résumé system.',
      link: 'https://github.com/joeitguy/modular-resume',
    },
    {
      title: 'Other Projects',
      description: 'Discover additional repositories and experiments in data engineering.',
      link: 'https://github.com/joeitguy/',
    },
    {
      title: 'Salesforce Trailblazer',
      description: 'View badges, completed courses, and Salesforce learning progress.',
      link: 'https://www.salesforce.com/trailblazer/jbodden1',
    },
    {
      title: 'Docker Hub',
      description: 'Demonstrates your full‑stack and deployment expertise',
      link: 'https://hub.docker.com/u/joeitguy',
    },
  ];

  return (
    <div className="index-container">
      <header className="hero">
        <h1>Welcome to Joe’s Modular Playground</h1>
        <p className="subtitle">Cloud‑native, containerized, and built to teach.</p>
      </header>

      <section className="grid-section">
        {cards.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </section>

      <footer className="footer">
        <p>Deployed across Azure, AWS, GCP, and Heroku. Built with ❤️ in Poway, CA.</p>
      </footer>
    </div>
  );
};

export default IndexPage;
